import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '~/app/rootReducer';
import type { BDRequestType } from '~/common/models/apis/apiResponse.model';
import {
  getOperationStatus,
  IDLE_OPERATION_STATUS,
} from '~/common/utils/store/selector.helper';

export const selectCamerasSettingsState = (state: RootState) =>
  state.camerasSettings;

export const selectCamerasSettings = createSelector(
  selectCamerasSettingsState,
  (state) => state.settings
);

export const selectCamerasSettingsFetchContext = createSelector(
  selectCamerasSettingsState,
  (state) => state.fetchSettingsContext
);

export const getCamerasSettingsOperationStatus = (requestType: BDRequestType) =>
  createSelector(
    selectCamerasSettingsState,
    (state) => getOperationStatus(state, requestType) || IDLE_OPERATION_STATUS
  );
